/**
 * Nidra Theme Core JavaScript
 * Announcement bar rotation, mobile drawer, sticky header & interaction helpers
 */
(function() {
  const announcements = [
    "Only 13 pillows left in this batch — Ships in 24h across India",
    "Order in the next few hours for today’s dispatch",
    "Cash on delivery available across India"
  ];

  document.addEventListener('DOMContentLoaded', () => {
    // 1. Announcement Bar Rotation
    const announcementEl = document.getElementById('NidraAnnouncementMsg');
    if (announcementEl) {
      let currentIndex = 0;
      setInterval(() => {
        currentIndex = (currentIndex + 1) % announcements.length;
        announcementEl.style.opacity = '0';
        setTimeout(() => {
          announcementEl.textContent = announcements[currentIndex];
          announcementEl.style.opacity = '1';
        }, 200);
      }, 5000);
    }

    // 2. Mobile Menu Drawer
    const mobileMenuOpen = document.getElementById('MobileMenuOpen');
    const mobileMenuClose = document.getElementById('MobileMenuClose');
    const mobileDrawer = document.getElementById('MobileDrawer');

    if (mobileMenuOpen && mobileDrawer) {
      mobileMenuOpen.addEventListener('click', () => {
        mobileDrawer.style.display = 'flex';
        mobileMenuOpen.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
    }

    if (mobileMenuClose && mobileDrawer) {
      mobileMenuClose.addEventListener('click', () => {
        mobileDrawer.style.display = 'none';
        if (mobileMenuOpen) mobileMenuOpen.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
      });
    }

    // 3. Ribbon Carousel Arrows on Homepage
    const ribbonPrev = document.getElementById('RibbonPrev');
    const ribbonNext = document.getElementById('RibbonNext');
    const photoStrip = document.getElementById('PhotoStrip');

    if (ribbonPrev && photoStrip) {
      ribbonPrev.addEventListener('click', () => {
        photoStrip.scrollBy({ left: -260, behavior: 'smooth' });
      });
    }
    if (ribbonNext && photoStrip) {
      ribbonNext.addEventListener('click', () => {
        photoStrip.scrollBy({ left: 260, behavior: 'smooth' });
      });
    }
  });
})();
